<div class="modal-header border-0 walkthrough-header">
  <div>
    <h5 class="modal-title fw-bold mb-1 text-white">
      <i class="bi bi-play-circle-fill me-2 text-white"></i>
      {{ selectedConfig.title }}
    </h5>
    <p class="mb-0 small text-white">
      {{ selectedConfig.subtitle }}
    </p>
  </div>
</div>

<div class="modal-body walkthrough-body">
  <div class="walkthrough-youtube-wrapper mb-4">
    <iframe
      class="walkthrough-youtube-frame"
      [src]="safeYoutubeUrl"
      [title]="selectedConfig.title"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      referrerpolicy="strict-origin-when-cross-origin"
    ></iframe>
  </div>

  <div class="walkthrough-section">
    <h6 class="fw-bold mb-3">{{ selectedConfig.helpTitle }}</h6>

    <div class="row g-3">
      <div
        class="col-md-6"
        *ngFor="let point of selectedConfig.helpPoints"
      >
        <div class="walkthrough-point-card">
          <div
            class="walkthrough-point-icon"
            [ngClass]="point.iconClass || 'bg-light'"
          >
            <i [class]="point.icon"></i>
          </div>

          <div>
            <div class="fw-semibold">{{ point.title }}</div>
            <p class="mb-0 small text-muted">
              {{ point.description }}
            </p>
          </div>
        </div>
      </div>
    </div>
    

    <div class="walkthrough-tip mt-4" *ngIf="selectedConfig.tip">
      <i class="bi bi-lightbulb-fill me-2"></i>
      {{ selectedConfig.tip }}
    </div>
  </div>
</div>

<div class="modal-footer border-0 pt-0">
  <button
    type="button"
    class="btn btn-outline-secondary px-4"
    (click)="closeModal()"
  >
    Close
  </button>
</div>

<!-- <div class="modal-footer border-0 pt-0 d-flex justify-content-between align-items-center">
  <small class="text-muted fw-semibold">
    {{ getDebugVideoInfo() }}
  </small>

  <button
    type="button"
    class="btn btn-outline-secondary px-4"
    (click)="closeModal()"
  >
    Close
  </button>
</div> -->